<template>
  <div>
    <b-modal id="signIn" ref="OTPModal" hide-header hide-footer centered>
      <div class="col-sm-9 col-md-10 mx-auto">
        <div class="modal-title">Verify your Deatils</div>

        <form
          @submit.prevent="validateBeforeSubmit('signInVerifyOTP')"
          data-vv-scope="signInVerifyOTP"
        >
          <!-- <div>{{errorMessage}}</div> -->
          <label>- ENTER OTP -</label>

          <input
            name="username"
            type="text"
            v-validate="'required'"
            placeholder="OTP"
            v-model="userDetails.OTP"
          />
          <!-- <span v-show="errors.has('signIn.username')"
                  class="help is-danger">{{ errors.first('signIn.username') }}</span>-->

          <input @click="verifyOTP()" type="submit" value="VERIFY OTP" />
        </form>
      </div>
    </b-modal>
    <div class="wrapper wrapper_mob">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-12 px-0">
            <b-tabs content-class="" class="user-profile-tabs profile-tabs">
              <b-tab title="Edit Profile" active class="profile-details-edit">
                <div class="custom-shadow">
                  <h4 class="font-weight-bold">{{$t("Edit Profile")}}</h4>
                  <div class="row align-items-center justify-content-center">
                  <div class="col-lg-6 mt-lg-4">
                    <div class="">
                      <input
                        class="form-control"
                        type="text"
                        v-validate="'required'"
                        placeholder="First Name"
                        v-model="userDetails.FirstName"
                      />
                    </div>
                    <div class="">
                      <input
                        class="form-control"
                        type="text"
                        v-validate="'required'"
                        placeholder="Last Name"
                        v-model="userDetails.LastName"
                      />
                    </div>
                    <div class="">
                      <b-form-group>
                        <b-form-radio-group
                          id="btn-radios-2"
                          v-model="userDetails.Gender"
                          :options="genderOptions"
                          buttons
                          button-variant="outline-primary"
                          size="lg"
                          name="radio-btn-outline"
                        ></b-form-radio-group>
                      </b-form-group>
                    </div>
                    <!-- <div class="col-lg-5">
                      <input
                        class="form-control"
                        type="text"
                        v-validate="'required'"
                        placeholder="DOB"
                      />
                    </div> -->
                    <div class="">
                      <div class="mobile-country-field">
                        <div class="country-code-drop">
                          <b-dropdown
                            v-if="CountryCodeList.length > 0"
                            class="pc-input form-control"
                            :text="
                              userDetails.CountryCode == '0'
                                ? defaultCountryCode
                                : userDetails.CountryCode
                            "
                            variant="default"
                            slot="append"
                          >
                            <b-dropdown-item
                              class
                              @click="onChangeCountry(country)"
                              v-for="(country, countryIndex) in CountryCodeList"
                              :key="countryIndex"
                              >{{ country.CountryISOCode }} ({{
                                country.CountryName
                              }})</b-dropdown-item
                            >
                          </b-dropdown>
                        </div>
                        <div>
                          <input
                            class="form-control"
                            type="text"
                            v-validate="'required'"
                            placeholder="Mobile Number"
                            v-model="userDetails.Mobile"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="">
                      <input
                        class="form-control"
                        type="text"
                        v-validate="'required'"
                        placeholder="Email"
                        disabled
                        v-model="userDetails.Email"
                      />
                    </div>
                    <!-- <div class="col-lg-5">
                      <input
                        class="form-control"
                        type="text"
                        v-validate="'required'"
                        placeholder="State"
                      />
                    </div>
                    <div class="col-lg-5">
                      <input
                        class="form-control"
                        type="text"
                        v-validate="'required'"
                        placeholder="City"
                      />
                    </div> -->
                    <div class="">
                      <button
                        class="btn btn-pink"
                        @click="onUpdateProfile()"
                        type="submit"
                      >
                        Update
                      </button>
                    </div>
                  </div>
                  </div>
                </div>
              </b-tab>
              <b-tab title="Preferences">
                <div class="custom-shadow">
                  <h6 class="font-weight-bold">
                    What do you Enjoy Watching?
                  </h6>
                  <div class="mt-3 mt-lg-5">
                    <h6 class="font-weight-bold">Genres</h6>
                    <ul class="preference-list">
                      <li
                        class="d-flex align-items-center"
                        v-for="(data, index) in Genres"
                        :key="index"
                      >
                        <input
                          type="checkbox"
                          @click="addPref(data, 'Genres')"
                          :checked="data.selected == true ? true : false"
                          :id="data + index"
                        />
                        <label :for="data + index" class="mb-0">
                          {{ data.Label }}
                        </label>
                      </li>
                    </ul>
                  </div>
                  <div class="my-3 my-lg-5">
                    <h6 class="font-weight-bold">Languages</h6>
                    <ul class="preference-list">
                      <li
                        class="d-flex align-items-center"
                        v-for="(data, index) in Languages"
                        :key="index"
                      >
                        <input
                          type="checkbox"
                          @click="addPref(data, 'Languages')"
                          :checked="data.selected == true ? true : false"
                          :id="data + index"
                        />
                        <label :for="data + index" class="mb-0">
                          {{ data.Label }}
                        </label>
                      </li>
                    </ul>
                  </div>
                  <!-- <div class="my-3 my-lg-5">
                    <h6 class="font-weight-bold">Events</h6>
                    <ul class="preference-list">
                      <li
                        class="d-flex align-items-center"
                        v-for="(data, index) in Events"
                        :key="index"
                      >
                        <input
                          type="checkbox"
                          @click="addPref(data, 'Events')"
                          :checked="data.selected == true ? true : false"
                          :id="data + index"
                        />
                        <label :for="data + index" class="mb-0">
                          {{ data.Label }}
                        </label>
                      </li>
                    </ul>
                  </div> -->
                  <!-- <div class="my-3 my-lg-5">
                    <h6 class="font-weight-bold">Sports</h6>
                    <ul class="preference-list">
                      <li
                        class="d-flex align-items-center"
                        v-for="(data, index) in Sports"
                        :key="index"
                      >
                        <input
                          type="checkbox"
                          @click="addPref(data, 'Sports')"
                          :checked="data.selected == true ? true : false"
                          :id="data + index"
                        />
                        <label :for="data + index" class="mb-0">
                          {{ data.Label }}
                        </label>
                      </li>
                    </ul>
                  </div> -->
                </div>
              </b-tab>
              <!-- <b-tab title="Notifications">
              <div>
                <p class="font-weight-bold">Phone Number Change Notification</p>
                <div class="notification-grid mt-lg-4 mt-3">
                  <div>
                    <input type="checkbox" id="sms" />
                    <label for="sms" class="mb-0"> SMS </label>
                  </div>
                  <div>
                    <input type="checkbox" id="email" />
                    <label for="email" class="mb-0"> Email </label>
                  </div>
                </div>
              </div>
              <div class="my-5">
                <p class="font-weight-bold">Deactivate Account Notification</p>
                <div class="notification-grid mt-lg-4 mt-3">
                  <div>
                    <input type="checkbox" id="sms" />
                    <label for="sms" class="mb-0"> SMS </label>
                  </div>
                  <div>
                    <input type="checkbox" id="email" />
                    <label for="email" class="mb-0"> Email </label>
                  </div>
                </div>
              </div>
              <div>
                <p class="font-weight-bold">
                  Get Notification for New Movies/Events
                </p>
                <div class="notification-grid mt-lg-4 mt-3">
                  <div>
                    <input type="checkbox" id="sms" />
                    <label for="sms" class="mb-0"> SMS </label>
                  </div>
                  <div>
                    <input type="checkbox" id="email" />
                    <label for="email" class="mb-0"> Email </label>
                  </div>
                </div>
              </div>
              <div class="mt-4">
                <button class="btn btn-pink">Update</button>
              </div>
            </b-tab> -->
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { makeRequest } from "@/helper/internet.js";
import {
  LanguageService,
  CountryService,
  TokenService
} from "@/services/storage.service";
export default {
  data() {
    return {
      Genres: [],
      Languages: [],
      Events: [],
      Sports: [],
      userDetails: [],
      _userDetails: [],
      genderOptions: [
        { text: "Male", value: "1" },
        { text: "Female", value: "0" }
      ],
      CountryCodeList: [],
      errorMessage: "",
      successMessage: "",
      message: "",
      moviesData: [
        "Urban",
        "Thriller",
        "Speculative",
        "Slice",
        "Of",
        "Life",
        "Science-Fiction",
        "Satire",
        "Saga",
        "Romance",
        "Philosophical",
        "Paranoid",
        "Musical",
        "Mystery",
        "Horror",
        "Historical",
        "Fantasy",
        "Family",
        "Erotica",
        "Documentary",
        "Drama",
        "Crime",
        "Comedy",
        "Biography",
        "Animation",
        "Adventure",
        "Action"
      ],
      eventsData: [
        "Class",
        "Seminar",
        "Sales and Marketing",
        "Finance",
        "StartUps",
        "Educators",
        "Dance",
        "Music",
        "Dinning and Music Concerts",
        " Food and Drink",
        " Exhibitions"
      ],
      langugageData: [
        "English",
        "Philipino",
        "Kannada",
        "Arabic",
        "Oriya",
        "Malayalam",
        "Punjabi",
        "Chinese",
        "Hindi (Dubbed)",
        "Norweaian",
        "Thai",
        "Tamil"
      ]
    };
  },

  beforeMount() {
    this.getMyPref();
    this.fetchUserDetails();
    this.getAllGetCountryList();
  },
  methods: {
    getAllGetCountryList: function() {
      makeRequest("/GetCountryCode", "POST", null, {})
        .then(response => {
          const { error, res } = response;
          if (res.data.Status) {
            this.CountryCodeList = res.data.List;
            this.userDetails.CountryCode = res.data.Default.CountryCode;
            this.defaultCountryCode = res.data.Default.CountryCode;
          }
        })
        .catch(error => {
          console.log("Error", error);
          //   resolve(null);
        });
    },
    onChangeCountry: function(country) {
      console.log("country :", country);
      this.defaultCountryCode = country.CountryISOCode;
    },
    fetchUserDetails: function() {
      let token = TokenService.getToken();
      makeRequest(`/GetProfile`, "POST", token, null)
        .then(result => {
          this.userDetails = result.res.data;
          // this._userDetails = result.res.data;
          // this.message = this.userDetails.ReferalCodeURL;
          // this.referralHistory = this.userDetails.userreflegdata
          //   ? this.userDetails.userreflegdata
          //   : [];
          // console.log("URL", this.referralHistory);
        })
        .catch(error => {
          console.log(" Error", error);
        });
    },
    onUpdateProfile() {
      let token = TokenService.getToken();
      let payload = {
        FirstName: this.userDetails.FirstName,
        LastName: this.userDetails.LastName,
        CountryCode: this.userDetails.CountryCode,
        Mobile: this.userDetails.Mobile,
        Gender: this.userDetails.Gender,
        Email: this.userDetails.Email
      };
      console.log("update payload :", payload);
      makeRequest(`/UpdateProfile`, "POST", token, payload)
        .then(result => {
          console.log(result.res.data.Status);
          if (result.res.data.Status) {
            if (
              result.res.data.hasOwnProperty("verify") &&
              result.res.data.verify
            ) {
              this.$refs.OTPModal.show();
            }
            this.$toasted.show("Profile has been updated successfully");
            setTimeout(() => {
              this.$toasted.clear();
            }, 5000);
          } else {
            this.userDetails = this._userDetails;

            this.errorMessage = result.res.data.Message;
          }
        })
        .catch(error => {
          this.userDetails = this._userDetails;
          console.log(this.userDetails);
          console.log(" Error", error);
        });
    },
    addPref(data, type) {
      let payload = {
        ID: data.ID,
        PreferenceType: type,
        Active: data.selected == true ? 0 : 1
      };
      makeRequest("/AddPreferences", "POST", null, payload)
        .then(response => {
          const { error, res } = response;

          if (!error && res.data.Status) {
            this.getMyPref();
            // this.Genres=res.data.Genres
            // this.Languages=res.data.Languages
            // this.Events=res.data.Events
            // this.Sports=res.data.Sports
            console.log(res.data, "res.data.jitu");
            //this.countries = res.data.List;
          }
        })
        .catch(error => {
          console.log("Error", error);
          //   resolve(null);
        });
    },
    getMyPref() {
      this.showLoading();
      makeRequest("/GetPreferences", "POST", null, {})
        .then(response => {
          const { error, res } = response;

          if (!error && res.data.Status) {
            this.Genres = res.data.Genres;
            this.Languages = res.data.Languages;
            this.Events = res.data.Events;
            this.Sports = res.data.Sports;
            console.log(res.data, "res.data.jitu");
            //this.countries = res.data.List;
          }
          this.hideLoading();
        })
        .catch(error => {
          this.hideLoading();
          console.log("Error", error);
          //   resolve(null);
        });
    }
  }
};
</script>

<style scoped>
  
</style>



// WEBPACK FOOTER //
// src/components/pages/userProfile3.vue